// system-apis.ts
import { useAuth } from '../contexts/AuthContext';
import { SYSTEM_INFO_URL } from '../config/api-config';
import { createApiHeadersGetter } from '../utils/api-headers';

interface SystemInfo {
  version: string;
}

export const useSystemApi = () => {

  const { getAuthToken } = useAuth();
  const getHeaders = createApiHeadersGetter(getAuthToken);

  const getSystemInfo = async (getSystemInfo: boolean = false): Promise<SystemInfo> => {
    try {
        console.log('Fetching system info using API');
        const headers = await getHeaders();

        const response = await fetch(SYSTEM_INFO_URL, {
        method: 'GET',
        headers
      });

      console.log('API Response:', response);
      if (!response.ok) {
        throw new Error('Failed to fetch system info');
      }

      return response.json();
    } catch (error) {
      console.error('Error fetching system info:', error);
      throw error;
    }
  }

  return {
    getSystemInfo
  };
};